/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import * as VehicleActions from '@vehicles/store/vehicles.actions';
import { initialState, VehiclesState } from '@vehicles/store/vehicles.state';

export function vehiclesReducer(state = initialState, action: VehicleActions.VehicleActions): VehiclesState {
  switch (action.type) {
    case VehicleActions.LOAD_VEHICLES_SUCCESS:
      return {
        ...state,
        vehicles: action.vehicles,
        isActionPending: false
      };
    case VehicleActions.LOAD_VEHICLE:
    case VehicleActions.LOAD_VEHICLES:
      return {
        ...state,
        isActionPending: true
      };
    case VehicleActions.LOAD_VEHICLES_FAILURE:
      return {
        ...state,
        isActionPending: false
      };
    case VehicleActions.LOAD_VEHICLE_SUCCESS:
      return {
        ...state,
        isActionPending: false,
        currentVehicle: action.vehicle
      };
    case VehicleActions.INIT:
    case VehicleActions.LOAD_LICENCE_CLASSES_SUCCESS:
      return {
        ...state,
        licenseClasses: action.licenceClasses
      };
    default:
      return state;
  }
}
